let config = {
    brandName: '',
    backgroundColor: '',
    buttonColor: '',
    buttonHoverColor: '',
    logoUrl: '',
    logoMobileUrl: '',
    hrefColor: '',
    coverUrl: '',
    coverMobileUrl: '',
    footerText: '',
    headerText: '',
    headerTextColor: '',
    buttonTextColor: '',
    textColor: '',
    mainBackgroundColor: '',
    brandingColor: '',
    logoDesktopWidth: '',
    logoMobileWidth: '',
    brandingPosition: '',
    userCircleUrl: '',
    logoTop: '',
    logoTopForget: '',
    brandingPositionForget: '',
    mobileCoverUrl: '',
    mobileCoverDesktopUrl: '',
    appsLogoUrl: '',
    appsLogoMobileUrl: '',
    pinUrl: '',
    pinMobileUrl: '',
    settingsIconUrl: ''
}

switch (window.location.hostname) {
    case 'sso-web.cocentric.ai' || 'sso-web-int.cocentric.ai' || 'ennismore-int.cocentric.ai' || 'ennismore.cocentric.ai':
        config.brandName = 'Ennismore';
        config.backgroundColor = '#3E3E3E';
        config.buttonColor = '#A3BBAD';
        config.buttonHoverColor = '#778a7f';
        config.logoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/ennismore_logo_colour.png';
        config.logoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/ennismore_logo_colour.png';
        config.hrefColor = '#2F1FAF';
        config.coverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/verticalCover.png';
        config.coverMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/horizontalCover.png';
        config.footerText = 'EnnismoreID';
        config.headerText = 'EnnismoreID';
        config.buttonTextColor = '#000000';
        config.textColor = '#000000';
        config.headerTextColor = '#000000';
        config.mainBackgroundColor = '#E9E3DD';
        config.brandingColor = '#6C6C6C';
        config.logoDesktopWidth = '150px';
        config.logoMobileWidth = '100px';
        config.brandingPosition = '85%';
        config.userCircleUrl = '';
        config.logoTop = '20%';
        config.logoTopForget = '12%';
        config.logoLeft = '100%';
        config.brandingPositionForget = '126%';
        config.mobileCoverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/app-mobile-cover.png';
        config.mobileCoverDesktopUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-desktop-cover.png';
        config.appsLogoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-desktop.png';
        config.appsLogoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-mobile.png';
        config.pinUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin.png';
        config.pinMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin.png';
        config.settingsIconUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/settings-02.png';
        config.apiContainer = 'api-container';
        config.mainContainer = 'main-container';
        config.imageSection = 'image-section';
        config.formSection = 'form-section';
        config.textSection = 'text-section';
        config.brandingOne = 'branding-one';
        config.brandingTwo = 'branding-two';
        break;
    case 'gleneagles.cocentric.ai':
        config.brandName = 'Gleneagles';
        config.backgroundColor = '#03390F';
        config.buttonColor = '#1C4422';
        config.buttonHoverColor = '#021e08';
        config.logoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/blink-logo.png';
        config.logoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/blink-logo.png';
        config.hrefColor = '#1C4422';
        config.coverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/gleneagles-cover-desktop.png';
        config.coverMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/gleneagles-cover-mobile.png';
        config.footerText = 'ConnectID';
        config.headerText = 'ConnectID';
        config.buttonTextColor = '#FFFFFF';
        config.textColor = '#151718';
        config.headerTextColor = '#1C4422';
        config.mainBackgroundColor = '#FFFFFF';
        config.brandingColor = '#8B8B8B';
        config.logoDesktopWidth = '402px'; 
        config.logoMobileWidth = '180px';
        config.brandingPosition = '90%';
        config.userCircleUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/user-circle.png';
        config.logoTop = '15%';
        config.logoTopForget = '6%';
        config.logoLeft = '100%';
        config.brandingPositionForget = '132%';
        config.mobileCoverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-mobile-cover-gg.png';
        config.mobileCoverDesktopUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-desktop-cover-gg.png';
        config.appsLogoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-desktop.png';
        config.appsLogoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-mobile.png';
        config.pinUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin-02-gg.png';
        config.pinMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin-02-gg-1.png';
        config.settingsIconUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/settings-02-gg-1.png';
        config.apiContainer = 'api-container-blink';
        config.mainContainer = 'main-container-blink';
        config.imageSection = 'image-section-blink';
        config.formSection = 'form-section-blink';
        config.textSection = 'text-section-blink';
        config.brandingOne = 'branding-one-blink';
        config.brandingTwo = 'branding-two-blink';
        break;
    case 'bistrotpierre.cocentric.ai':
        config.brandName = 'Bistrot Pierre';
        config.backgroundColor = '#0050A0';
        config.buttonColor = '#0050A0';
        config.buttonHoverColor = '#003061';
        config.logoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/logo-bp-desktop.png';
        config.logoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/logo-bp-mobile.png';
        config.hrefColor = '#0050A0';
        config.coverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/cover-bp-desktop.png';
        config.coverMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/cover-bp-mobile.png';
        config.footerText = 'ConnectID';
        config.headerText = 'ConnectID';
        config.buttonTextColor = '#FFFFFF';
        config.textColor = '#151718';
        config.headerTextColor = '#0050A0';
        config.mainBackgroundColor = '#FFFFFF';
        config.brandingColor = '#8B8B8B';
        config.logoDesktopWidth = '402px'; 
        config.logoMobileWidth = '180px';
        config.brandingPosition = '84%';
        config.userCircleUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/user-circle-bp.png';
        config.logoTop = '20%';
        config.logoTopForget = '6%';
        config.logoLeft = '100%';
        config.brandingPositionForget = '132%';
        config.mobileCoverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-mobile-cover-gg.png';
        config.mobileCoverDesktopUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-desktop-cover-gg.png';
        config.appsLogoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-desktop.png';
        config.appsLogoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-mobile.png';
        config.pinUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin-02-gg.png';
        config.pinMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin-02-gg-1.png';
        config.settingsIconUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/settings-02-gg-1.png';
        config.apiContainer = 'api-container';
        config.mainContainer = 'main-container';
        config.imageSection = 'image-section';
        config.formSection = 'form-section';
        config.textSection = 'text-section';
        config.brandingOne = 'branding-one';
        config.brandingTwo = 'branding-two';
        break;
    case 'fridayfurniture.cocentric.ai':
        config.brandName = 'FridayFurniture';
        config.backgroundColor = '#151718';
        config.buttonColor = '#2900F1';
        config.buttonHoverColor = '#160082';
        config.logoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/friday_logo_desktop.png';
        config.logoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/friday_logo_mobile.png';
        config.hrefColor = '#2900F1';
        config.coverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/friday_cover_desktop1.png';
        config.coverMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/friday_cover_mobile.png';
        config.footerText = 'ConnectID © 2025 Cocentric Group Limited';
        config.headerText = 'ConnectID';
        config.buttonTextColor = '#FFFFFF';
        config.textColor = '#151718';
        config.headerTextColor = '#2900F1';
        config.mainBackgroundColor = '#FFFFFF';
        config.brandingColor = '#8B8B8B';
        config.logoDesktopWidth = '182px'; 
        config.logoMobileWidth = '100px';
        config.brandingPosition = '87%';
        config.userCircleUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/user-circle-ff.png';
        config.logoTop = '20%';
        config.logoTopForget = '12%';
        config.logoLeft = '100%';
        config.brandingPositionForget = '128%';
        config.mobileCoverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/app-mobile-cover.png';
        config.mobileCoverDesktopUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-desktop-cover.png';
        config.appsLogoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-desktop-ff.png';
        config.appsLogoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-mobile-ff.png';
        config.pinUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin-02-ff.png';
        config.pinMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin-02-ff-1.png';
        config.settingsIconUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/settings-02-ff-1.png';
        config.apiContainer = 'api-container';
        config.mainContainer = 'main-container';
        config.imageSection = 'image-section';
        config.formSection = 'form-section';
        config.textSection = 'text-section';
        config.brandingOne = 'branding-one';
        config.brandingTwo = 'branding-two';
        break;
    default:
        config.brandName = 'FridayFurniture';
        config.backgroundColor = '#151718';
        config.buttonColor = '#2900F1';
        config.buttonHoverColor = '#160082';
        config.logoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/friday_logo_desktop.png';
        config.logoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/friday_logo_mobile.png';
        config.hrefColor = '#2900F1';
        config.coverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/friday_cover_desktop1.png';
        config.coverMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/friday_cover_mobile.png';
        config.footerText = 'ConnectID © 2025 Cocentric Group Limited';
        config.headerText = 'ConnectID';
        config.buttonTextColor = '#FFFFFF';
        config.textColor = '#151718';
        config.headerTextColor = '#2900F1';
        config.mainBackgroundColor = '#FFFFFF';
        config.brandingColor = '#8B8B8B';
        config.logoDesktopWidth = '182px'; 
        config.logoMobileWidth = '100px';
        config.brandingPosition = '87%';
        config.userCircleUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/user-circle-ff.png';
        config.logoTop = '20%';
        config.logoTopForget = '12%';
        config.logoLeft = '100%';
        config.brandingPositionForget = '128%';
        config.mobileCoverUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/app-mobile-cover.png';
        config.mobileCoverDesktopUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-desktop-cover.png';
        config.appsLogoUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-desktop-ff.png';
        config.appsLogoMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/apps-logo-mobile-ff.png';
        config.pinUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin-02-ff.png';
        config.pinMobileUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/pin-02-ff-1.png';
        config.settingsIconUrl = 'https://eussocontent.blob.core.windows.net/sso-custom-ui/settings-02-ff-1.png';
        config.apiContainer = 'api-container';
        config.mainContainer = 'main-container';
        config.imageSection = 'image-section';
        config.formSection = 'form-section';
        config.textSection = 'text-section';
        config.brandingOne = 'branding-one';
        config.brandingTwo = 'branding-two';
        break;
}

export default config;